import React, { useState , useEffect} from 'react';
import { Box, TextField,FormControl, FormControlLabel, Radio, RadioGroup, Typography, Slider} from "@mui/material";
import { ItemContainer } from './ui-components/containers';




const defaultLabels = [
    "Very slightly or not at all",
    "A little",
    "Moderately",
    "Quite a bit",
    "Extremely"
];


const LikertTableHeader = ({
    likertScale = defaultLabels,
}) => {
    return (
        <Box
            sx={{
                display: 'flex', 
                paddingLeft: '200px', 
            }}
        >
            {likertScale.map((t, i) => (
                <Box key={i} sx={{ 
                    display: 'flex',
                    alignItems: 'flex-end', // Align text to the bottom
                    width: '100px', 
                    margin: '0 9.9px', 
                    textAlign: 'center' 
                }}>
                    <Typography sx={{ width: '100%' }}>{t}</Typography>
                </Box>
            ))}
        </Box>
    );
};


const LikertTableRow = ({
    item = "Test.",
    likertScale = defaultLabels,
    value = -99,
    updateValue = (v) => console.log('selected ', v)
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' , flexWrap: 'wrap'}}> 
            <Typography sx={{ width: '250px', flexShrink: 100, marginRight: '8px',wordWrap: 'break-word'  }}> 
                {item}   
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}> 
                <RadioGroup row value={value} onChange={updateValue}>
                    {likertScale.map((v, i) => (
                        <FormControlLabel
                            value={i}
                            key={v}
                            control={<Radio />}
                            label={''}
                            sx={{ width: '112px' }}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </Box>
    );
};



export const LikertEmotions = ({
    prompt = 'Please indicate the extent to which you are experiencing the following emotions:',
    handleUpdate = (data) => console.log(data),
    emotions
}) => {

    const [emotionData, setEmotionData] = useState(Array(20).fill(-99));

    const handleEmotionChange = (emotionIndex) => (event) => {
        const newValues = emotionData.map((v, i) => {
            if (i === emotionIndex) {
                return parseInt(event.target.value, 10); // Convert string to number
            } else {
                return v;
            }
        });
        handleUpdate(newValues);
        setEmotionData(newValues);
    };

    return (
        <ItemContainer>
        <Typography variant="h6" sx={{ marginBottom: '20px' }}>{prompt}</Typography> 

            <LikertTableHeader likertScale={defaultLabels} />
            {emotions.map((emotion, i) => (
                <React.Fragment key={i}>
                    <LikertTableRow
                        likertScale={defaultLabels}
                        item={emotion}
                        updateValue={handleEmotionChange(i)}
                        value={emotionData[i]}
                    />
{(i + 1) % 7 === 0 && i !== 20 - 1 && (
                        <>
                            <Box sx={{ height: '20px' }} /> 
                            <LikertTableHeader likertScale={defaultLabels} />
                        </>
                    )}                </React.Fragment>
            ))}
        </ItemContainer>
    );
};


export const SlidingScale = ({ question, leftLabel, rightLabel, handleUpdate }) => {
    const [sliderValue, setSliderValue] = useState(50); 

    const handleChange = (event, newValue) => {
        setSliderValue(newValue);
        if (handleUpdate) {
            handleUpdate(newValue);
        }
    };

    return (
        <>
            <div>{question}</div>
            <div style={{ height: '20px' }}></div> 

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" component="span" sx={{ color: 'gray' }}><strong>{leftLabel}</strong></Typography>
                <Typography variant="body2" component="span" sx={{ color: 'gray' }}><strong>{rightLabel}</strong></Typography>
            </div>

            <Slider
                value={sliderValue}
                onChange={handleChange}
                step={1}
                min={0}
                max={100}
                sx={{ marginBottom: '0px' , color: 'gray'}}
            />

                        <div style={{ height: '10px' }}></div> 

        </>
    );
};




export const MultipleChoiceQuestion = ({ question, options, handleUpdate }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [otherResponse, setOtherResponse] = useState('');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        if (handleUpdate) {
            handleUpdate(event.target.value);
        }
    };

    return (
        <div>
            <Typography gutterBottom>{question}</Typography>
            <FormControl component="fieldset">
                <RadioGroup value={selectedOption} onChange={handleChange}>
                    {options.map((option, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                            <FormControlLabel
                                value={option}
                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />} // Smaller radio buttons
                                label={option}
                                sx={{ marginY: 0 }} // Reduced vertical space between options
                            />
                            {option === "Other" && (
                                <TextField
                                    placeholder="Please specify"
                                    value={otherResponse}
                                    onChange={(e) => setOtherResponse(e.target.value)}
                                    size="small"
                                    variant="outlined"
                                    sx={{ marginLeft: 2 }}
                                />
                            )}
                        </div>
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    );
};





const QuestionnaireLikertTableHeader = ({
    likertScale = defaultLabels,
}) => {
    return (
        <Box
            sx={{
                display: 'flex', 
                paddingLeft: '285px', 
            }}
        >
            {likertScale.map((t, i) => (
                <Box key={i} sx={{ 
                    display: 'flex',
                    alignItems: 'flex-end', // Align text to the bottom
                    width: '100px', 
                    margin: '0 9.9px', 
                    textAlign: 'center' 
                }}>
                    <Typography sx={{ width: '100%' }}>{t}</Typography>
                </Box>
            ))}
        </Box>
    );
};


const QuestionnaireLikertTableRow = ({
    item = "Test.",
    likertScale = defaultLabels,
    value = -99,
    updateValue = (v) => console.log('selected ', v)
}) => {
    return (

        <Box sx={{ display: 'flex', alignItems: 'center' , flexWrap: 'wrap', minHeight: '80px'}}> 
            <Typography sx={{ width: '300px', flexShrink: 100, marginRight: '40px',wordWrap: 'break-word'  }}> 
                {item}   
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}> 
                <RadioGroup row value={value} onChange={updateValue}>
                    {likertScale.map((v, i) => (
                        <FormControlLabel
                            value={i}
                            key={v}
                            control={<Radio />}
                            label={''}
                            sx={{ width: '112px' }}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </Box>
    );
};



export const MatrixQuestion = ({title, rows, columns,
    handleUpdate = (data) => console.log(data)
}) => {
    const [responses, setResponses] = useState(Array(rows.length).fill(-99));
    useEffect(() => {
        setResponses(Array(rows.length).fill(-99));
    }, [rows]);

    const handleResponseChange = (dataIndex) => (event) => {
        const newValues = responses.map((v, i) => {
            if (i === dataIndex) {
                return parseInt(event.target.value, 10); 
            } else {
                return v;
            }
        });
        handleUpdate(newValues);
        setResponses(newValues);
    };

    return (
        <ItemContainer>
        <Typography variant="h6" sx={{ marginBottom: '20px' }}>{title}</Typography> 

            <div style={{ height: '10px' }}></div> 

            <QuestionnaireLikertTableHeader likertScale={columns} />
            {rows.map((row, i) => (
                <React.Fragment key={i}>
                    <QuestionnaireLikertTableRow
                        likertScale={columns}
                        item={row}
                        updateValue={handleResponseChange(i)}
                        value={responses[i]}
                    />
{(i + 1) % 8 === 0 && i !== rows.length - 1 && (
                        <>
                            <Box sx={{ height: '20px' }} /> 
                            <QuestionnaireLikertTableHeader likertScale={columns} />
                        </>
                    )}                </React.Fragment>
            ))}
        </ItemContainer>
    );
};








const LikertTableTimeHeader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between', // Space out the labels
                paddingLeft: '260px',
                paddingRight: '0px', // Add padding on the right
            }}
        >
            <Typography sx={{ fontWeight: 'bold', color: 'grey' }}>0 hours</Typography>
            <Typography sx={{ fontWeight: 'bold', color: 'grey' }}>24 hours</Typography>
        </Box>
    );
};




const LikertTableTimeRow = ({
    item = "Test.",
    value = 0,
    updateValue = (v) => console.log('selected ', v)
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', minHeight: '100px' }}> 
            <Typography sx={{ width: '250px', flexShrink: 0, marginRight: '20px' }}> 
                {item}
            </Typography>
            <Slider
                value={value}
                onChange={updateValue}
                min={0}
                max={24}
                valueLabelDisplay="auto"
                sx={{ marginBottom: '0px' , color: 'gray'}}
            />
        </Box>
    );
};




export const TimeMatrixQuestion = ({title, rows, 
    handleUpdate = (data) => console.log(data)
}) => {

    const [responses, setResponses] = useState(Array(rows.length).fill(-99));

    const handleResponseChange = (dataIndex) => (event, newValue) => {
        const newValues = responses.map((v, i) => {
            if (i === dataIndex) {
                return newValue;
            } else {
                return v;
            }
        });
        setResponses(newValues);
        handleUpdate(newValues);
        console.log(newValues)
    };

    return (
       <Box>
            <Typography variant="h6" sx={{ marginBottom: '20px' }}>{title}</Typography>
            <LikertTableTimeHeader />

            {rows.map((row, i) => (
                <LikertTableTimeRow
                    key={i} // Add a unique key for each row
                    item={row}
                    updateValue={handleResponseChange(i)}
                    value={responses[i]}
                />
            ))}
        </Box>
    );
};



    
